/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import applySelectionCommitToState from './helpers/applySelectionCommitToState';
import toSelectionEntry from './helpers/toSelectionEntry';
import { buildSelectionKey, isSelectableItem } from './helpers/selectionKey';

export const replaceProductSelection = createAction('products/replaceProductSelection');

export const reducer = (builder) => {
  builder.addCase(replaceProductSelection, (state, { payload }) => {
    const { item } = payload || {};
    if (!isSelectableItem(item)) return;

    const entry = toSelectionEntry(item);

    applySelectionCommitToState(state, {
      replaceEntries: [entry],
      lastClickedKey: buildSelectionKey(item),
      source: payload.source ?? 'tree',
      ...(payload.context !== undefined ? { context: payload.context } : {}),
    });
  });
};
